import { flattenChildren } from "..";
import { BlockPropsBase } from "../props";

export default function getChildren(props: BlockPropsBase) {
	return flattenChildren(props.content);
}

